import { useRecoilState, useSetRecoilState } from 'recoil';
import jwt_decode from 'jwt-decode';

import { CrtlAcessService } from 'shared/services/crtlAcess/crtlAcessService';
import { UsuariosService } from 'shared/services/usuarios/usuariosService';
import { sessionUser, erroLogin } from './atoms';
import { selectedOrganization } from 'shared/store/organization/atoms';
import { ICrtlAcessResponse, IJwtToken, ILoginFormData, IMeSession, IResponseError } from 'shared/types';
import { useSessionUser } from './selectors';
import { calculateRemainingTime } from 'shared/utils';

let logoutTimer: NodeJS.Timeout;

export const useSessionActions = () => {
  const [sessionUsr, setSessionUsr] = useRecoilState(sessionUser);
  const setErroLogin = useSetRecoilState(erroLogin);
  const setSelectedOrganization = useSetRecoilState(selectedOrganization);

  const getSessionUser = async () => {
    return useSessionUser();
  };

  const login = async (loginData: ILoginFormData) => {
    setSessionUsr(null);
    setSelectedOrganization(null);
    setErroLogin(null);

    CrtlAcessService
      .login(loginData)
      .then((response) => {
        if (response instanceof Error) {
          setSessionUsr(null);
          setErroLogin({ mensagem: response.message, codigo: 500, descricao: response.message });
          return;
        }
        const data: ICrtlAcessResponse & IResponseError = response;
        const { token, erro } = data;
        if (erro) {
          setSessionUsr(null);
          setErroLogin(erro);
          return;
        }
        if (token) {
          const { idUsuario, nome, email, exp } = <IJwtToken>jwt_decode(token);
          const SessionUsrTmp = {
            id: parseInt(idUsuario || '0', 10),
            name: nome || '',
            email: email || '',
            token: token,
            session: '',
            exp: exp || 0,
          };
          if (exp) {
            const remainingTime = calculateRemainingTime(exp * 1000);
            logoutTimer = setTimeout(logout, remainingTime);
          }
          setSessionUsr(SessionUsrTmp);
          setErroLogin(null);
          return;
        }
      })
      .catch(() => {
        setSessionUsr(null);
        return;
      });
  };
  const loginCrib = async (loginData: ILoginFormData) => {
    setSessionUsr(null);
    setSelectedOrganization(null);
    setErroLogin(null);

    CrtlAcessService
      .loginCrib(loginData)
      .then((response) => {
        if (response instanceof Error) {
          setSessionUsr(null);
          setErroLogin({ mensagem: response.message, codigo: 500, descricao: response.message });
          return;
        }
        const data: ICrtlAcessResponse & IResponseError = response;
        const { token, erro } = data;
        if (erro) {
          setSessionUsr(null);
          setErroLogin(erro);
          return;
        }
        if (token) {
          const { idUsuario, nome, email, exp } = <IJwtToken>jwt_decode(token);
          const SessionUsrTmp = {
            id: parseInt(idUsuario || '0', 10),
            name: nome || '',
            email: email || '',
            token: token,
            session: '',
            exp: exp || 0,
          };
          if (exp) {
            const remainingTime = calculateRemainingTime(exp * 1000);
            logoutTimer = setTimeout(logout, remainingTime);
          }
          setSessionUsr(SessionUsrTmp);
          setErroLogin(null);
          return;
        }
      })
      .catch(() => {
        setSessionUsr(null);
        return;
      });
  };

  const loginToken = async (token: string) => {
    setSessionUsr(null);
    setSelectedOrganization(null);
    setErroLogin(null);

    CrtlAcessService
      .loginToken(token)
      .then((response) => {
        if (response instanceof Error) {
          setSessionUsr(null);
          setErroLogin({ mensagem: response.message, codigo: 500, descricao: response.message });
          return;
        }
        const data: ICrtlAcessResponse & IResponseError = response;
        const { token, erro } = data;
        if (erro) {
          setSessionUsr(null);
          setErroLogin(erro);
          return;
        }
        if (token) {
          const { idUsuario, nome, email, exp } = <IJwtToken>jwt_decode(token);
          const SessionUsrTmp = {
            id: parseInt(idUsuario || '0', 10),
            name: nome || '',
            email: email || '',
            token: token,
            session: '',
            exp: exp || 0,
          };
          if (exp) {
            const remainingTime = calculateRemainingTime(exp * 1000);
            logoutTimer = setTimeout(logout, remainingTime);
          }
          setSessionUsr(SessionUsrTmp);
          setErroLogin(null);
          return;
        }
      })
      .catch(() => {
        setSessionUsr(null);
        return;
      });
  };

  const logout = async () => {
    try {
      //await authService.logout();
      if (logoutTimer) {
        clearTimeout(logoutTimer);
      }
    } catch (e) {
      //
    } finally {
      setSessionUsr(null);
      setSelectedOrganization(null);
      setErroLogin(null);
    }
  };

  return {
    login,
    loginCrib,
    logout,
    getSessionUser,
    loginToken
  };
};
